var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "form", staticClass: "form", attrs: { id: "form" } },
    [
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.authType === "login",
              expression: "this.authType === 'login'",
            },
          ],
          attrs: { "data-vv-scope": "form-1" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validate("form-1")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                staticClass: "inputx lower-input",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("form-1.email"),
                },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "email",
                  label: _vm.$t("auth.email_placeholder"),
                  "data-qa": "auth-email",
                },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-1.email"),
                    expression: "errors.has('form-1.email')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-1.email"),
                      expression: "errors.has('form-1.email')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-1.email")))]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "inputx",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has("form-1.password"),
                  },
                  attrs: {
                    "vs-size": "large",
                    type: _vm.showPass ? "text" : "password",
                    name: "password",
                    label: _vm.$t("auth.password_placeholder"),
                    "data-qa": "auth-password",
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password",
                  },
                }),
                _c("vs-button", {
                  staticClass: "btn-eye",
                  attrs: {
                    type: "fill",
                    icon: _vm.showPass ? "visibility_off" : "visibility",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showPass = !_vm.showPass
                    },
                  },
                }),
              ],
              1
            ),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("form-1.password"),
                  expression: "errors.has('form-1.password')",
                },
              ],
              staticClass: "fa fa-warning",
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-1.password"),
                    expression: "errors.has('form-1.password')",
                  },
                ],
                staticClass: "help is-danger",
              },
              [_vm._v(_vm._s(_vm.errors.first("form-1.password")))]
            ),
            _c("div", { staticClass: "forgot-link" }, [
              _c("p", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("auth.forgot")) +
                    "\n          "
                ),
                _c(
                  "a",
                  {
                    staticClass: "underline",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.forgot("form-1.email")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("auth.link")))]
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "vs-button",
                {
                  attrs: {
                    "vs-type": "filled",
                    color: "#2F1937",
                    type: "submit",
                    button: "submit",
                    "data-qa": "auth-submit",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("auth.login.button")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.authType === "signup" || this.authType === "partner",
              expression:
                "this.authType === 'signup' || this.authType === 'partner'",
            },
          ],
          attrs: { "data-vv-scope": "form-2" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validate("form-2")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                staticClass: "inputx",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("form-2.firstname"),
                },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "firstname",
                  label: _vm.$t("auth.firstname"),
                },
                model: {
                  value: _vm.form.firstname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "firstname", $$v)
                  },
                  expression: "form.firstname",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.firstname"),
                    expression: "errors.has('form-2.firstname')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.firstname"),
                      expression: "errors.has('form-2.firstname')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-2.firstname")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                staticClass: "inputx",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("form-2.lastname"),
                },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "lastname",
                  label: _vm.$t("auth.lastname"),
                },
                model: {
                  value: _vm.form.lastname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "lastname", $$v)
                  },
                  expression: "form.lastname",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.lastname"),
                    expression: "errors.has('form-2.lastname')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.lastname"),
                      expression: "errors.has('form-2.lastname')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-2.lastname")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|phone",
                    expression: "'required|phone'",
                  },
                ],
                staticClass: "inputx",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("form-2.phone"),
                },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "phone",
                  label: _vm.$t("auth.phone"),
                },
                model: {
                  value: _vm.form.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.phone"),
                    expression: "errors.has('form-2.phone')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.phone"),
                      expression: "errors.has('form-2.phone')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-2.phone")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                staticClass: "inputx lower-input",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("form-2.email"),
                },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "email",
                  label: _vm.$t("auth.email_placeholder"),
                },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.email"),
                    expression: "errors.has('form-2.email')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.email"),
                      expression: "errors.has('form-2.email')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-2.email")))]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "inputx",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has("form-2.password"),
                  },
                  attrs: {
                    "vs-size": "large",
                    type: _vm.showPass ? "text" : "password",
                    name: "password",
                    label: _vm.$t("auth.password_placeholder"),
                    autocomplete: "off",
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password",
                  },
                }),
                _c("vs-button", {
                  staticClass: "btn-eye",
                  attrs: {
                    type: "fill",
                    icon: _vm.showPass ? "visibility_off" : "visibility",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showPass = !_vm.showPass
                    },
                  },
                }),
              ],
              1
            ),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("form-2.password"),
                  expression: "errors.has('form-2.password')",
                },
              ],
              staticClass: "fa fa-warning",
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.password"),
                    expression: "errors.has('form-2.password')",
                  },
                ],
                staticClass: "help is-danger",
              },
              [_vm._v(_vm._s(_vm.errors.first("form-2.password")))]
            ),
          ]),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("vs-input", {
                staticClass: "inputx lower-input",
                class: { input: true },
                attrs: {
                  "vs-size": "large",
                  type: "text",
                  name: "promo",
                  label: _vm.$t("auth.promo_placeholder"),
                },
                model: {
                  value: _vm.form.promo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "promo", $$v)
                  },
                  expression: "form.promo",
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-2.email"),
                    expression: "errors.has('form-2.email')",
                  },
                ],
                staticClass: "fa fa-warning",
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.email"),
                      expression: "errors.has('form-2.email')",
                    },
                  ],
                  staticClass: "help is-danger",
                },
                [_vm._v(_vm._s(_vm.errors.first("form-2.email")))]
              ),
            ],
            1
          ),
          this.authType === "signup" || this.authType === "partner"
            ? _c("div", { staticClass: "input-wrapper checkbox-wrapper" }, [
                _c("label", { attrs: { for: "terms" } }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("auth.terms")) + "\n        "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "underline",
                      attrs: {
                        href: "https://www.mashup-web.com/mentions-legales-cgs",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.termslink")))]
                  ),
                ]),
                _c("div", { staticClass: "checkbox" }, [
                  _c("div", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.terms,
                          expression: "form.terms",
                        },
                      ],
                      class: {
                        input: true,
                        "is-danger": _vm.errors.has("form-2.terms"),
                      },
                      attrs: { name: "terms", id: "terms", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.form.terms)
                          ? _vm._i(_vm.form.terms, null) > -1
                          : _vm.form.terms,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.terms,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "terms", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "terms",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "terms", $$c)
                          }
                        },
                      },
                    }),
                    _vm._m(0),
                  ]),
                ]),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("form-2.terms"),
                      expression: "errors.has('form-2.terms')",
                    },
                  ],
                  staticClass: "fa fa-warning",
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-2.terms"),
                        expression: "errors.has('form-2.terms')",
                      },
                    ],
                    staticClass: "help is-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-2.terms")))]
                ),
              ])
            : _vm._e(),
          this.authType === "signup"
            ? _c("div", { staticClass: "input-wrapper checkbox-wrapper" }, [
                _c("label", { attrs: { for: "trial" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          _vm.form.promo && _vm.form.promo.length
                            ? "auth.trial.promo"
                            : "auth.trial"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _c("div", { staticClass: "checkbox" }, [
                  _c("div", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.trial,
                          expression: "form.trial",
                        },
                      ],
                      class: {
                        input: true,
                        "is-danger": _vm.errors.has("form-2.trial"),
                      },
                      attrs: { name: "trial", id: "trial", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.form.trial)
                          ? _vm._i(_vm.form.trial, null) > -1
                          : _vm.form.trial,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.trial,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "trial", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "trial",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "trial", $$c)
                          }
                        },
                      },
                    }),
                    _vm._m(1),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "vs-button",
                {
                  attrs: {
                    "vs-type": "filled",
                    color: "#2F1937",
                    type: "submit",
                    button: "submit",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("auth.signup.button")))]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("span", [_vm._v("check")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("span", [_vm._v("check")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }